module.exports = __webpack_public_path__ + "img/img_db_dt_top.bd721c54.png";